import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Plantillas de Gestión Agropecuaria',
    value: '$9.990',
    desc: 'Control de producción, costos y planificación'
  }, {
    title: 'Modelos de Contratos Rurales',
    value: '$7.990',
    desc: 'Listos para usar en clase'
  }, {
    title: 'Banco de Casos Prácticos',
    value: '$9.990',
    desc: 'Situaciones reales del campo'
  }, {
    title: 'Planificación Anual Completa',
    value: '$7.990',
    desc: 'Todo el año organizado'
  }];
  return <section className="bg-white py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <h2 className="text-xl md:text-2xl font-black text-[#1F3D2B] text-center mb-2 uppercase tracking-tight" data-id="element-18">
          🎁 BONUS DE REGALO
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mb-2" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#F5F6F7] border border-gray-200 rounded-lg p-2 relative overflow-hidden flex flex-col shadow-sm" data-id="element-20">
              <div className="absolute top-0 right-0 bg-[#D4A843] text-white text-[9px] font-black px-2 py-0.5 rounded-bl-lg z-10" data-id="element-21">
                #{i + 1}
              </div>
              <h3 className="text-xs md:text-sm font-black text-[#1F3D2B] mb-0.5 flex items-start gap-1 mt-1 leading-tight" data-id="element-22">
                <span className="text-[#D4A843]" data-id="element-23">🎁</span>
                <span data-id="element-24">{bonus.title}</span>
              </h3>
              <p className="text-gray-600 text-[10px] md:text-xs mb-1 ml-5" data-id="element-25">
                👉 {bonus.desc}
              </p>
              <div className="border-t border-gray-200 pt-1 flex justify-between items-center mt-auto" data-id="element-26">
                <span className="text-gray-400 line-through text-[10px]" data-id="element-27">
                  {bonus.value}
                </span>
                <span className="text-[#2E5A3E] font-black text-xs" data-id="element-28">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-xs mx-auto bg-white border-3 border-[#D4A843] rounded-xl p-2 text-center shadow-lg" data-id="element-29">
          <p className="text-gray-500 font-bold text-[10px] mb-0.5 uppercase tracking-wide" data-id="element-30">
            Valor total:
          </p>
          <p className="text-lg font-black text-gray-400 line-through mb-0.5" data-id="element-31">
            $35.960
          </p>
          <p className="text-xl md:text-2xl font-black text-[#D4A843]" data-id="element-32">
            🔥 HOY: GRATIS
          </p>
        </div>
      </div>
    </section>;
}